import { StrictMode, lazy, Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App.tsx';
import { AuthProvider } from './context/AuthContext';
import { createBrowserRouter, RouterProvider, Navigate, useLocation } from 'react-router-dom';
import SpinWheel from './pages/SpinWheel';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiesPolicy from './pages/CookiesPolicy';
import TermsOfService from './pages/TermsOfService';
import ResetPassword from './pages/ResetPassword';
import DashboardRouter from './pages/dashboard/DashboardRouter';
import DashboardLogin from './pages/dashboard/DashboardLogin';
import ArtistDashboard from './pages/dashboard/ArtistDashboard';
import { HelmetProvider } from 'react-helmet-async';
// Tattoo service pages are now fully static HTML (served directly by Netlify);
// they are no longer React routes. Do not re-import them here.
import NotFound from './pages/NotFound';
import AthensTattooStudioLocations from './pages/AthensTattooStudioLocations';
//Blogs
import BlogIndex from "./pages/blog/BlogIndex.tsx";
import FirstTattooAthens from "./pages/blog/first-tattoo-athens.tsx";
import TattooAfterCareAthens from "./pages/blog/tattoo-aftercare-athens.tsx";
import TattooCareAthens from "./pages/blog/tattoo-care-athens.tsx";
import TattooTrendsAthens from "./pages/blog/tattoo-trends-athens.tsx";
import TattooStylesAthens from "./pages/blog/tattoo-styles-athens.tsx";
import TattooCostAthens from "./pages/blog/tattoo-cost-athens.tsx";
import TattooArtistAthens from "./pages/blog/tattoo-artist-athens.tsx";
import FineLineTattooGuideAthens from "./pages/blog/fine-line-tattoo-guide-athens.tsx";
import TattooCoverUpAthens from "./pages/blog/tattoo-cover-up-athens.tsx";
import TattooPainGuideAthens from "./pages/blog/tattoo-pain-guide-athens.tsx";
import TattooPlacementGuideAthens from "./pages/blog/tattoo-placement-guide-athens.tsx";
import MinimalTattooIdeasAthens from "./pages/blog/minimal-tattoo-ideas-athens.tsx";
import TattooStyleGuideAthens from "./pages/blog/tattoo-style-guide-athens.tsx";
import FirstTattooDesignAthens from "./pages/blog/first-tattoo-design-athens.tsx";
import TattooSymbolismGuideAthens from "./pages/blog/tattoo-symbolism-guide-athens.tsx";
import MeaningfulTattooIdeasAthens from "./pages/blog/meaningful-tattoo-ideas-athens.tsx";
import SummerTattooCareAthens from "./pages/blog/summer-tattoo-care-athens.tsx";
import LaserVsCoverUpAthens from "./pages/blog/laser-vs-cover-up-athens.tsx";
import WalkInVsAppointmentAthens from "./pages/blog/walk-in-vs-appointment-athens.tsx";
import BestTimeForTattooAthens from "./pages/blog/best-time-for-tattoo-athens.tsx";
import FineLineTattooAthens from "./pages/blog/fine-line-tattoo-athens.tsx";
import CustomTattooProcessAthens from "./pages/blog/custom-tattoo-process-athens.tsx";
import TattooDifficultPlacementsAthens from "./pages/blog/tattoo-difficult-placements-athens.tsx";
import TattooTimingAthens from "./pages/blog/tattoo-timing-athens.tsx";
import SmallTattooCostAthens from "./pages/blog/small-tattoo-cost-athens.tsx";
import TattooTouchUpGuideAthens from "./pages/blog/tattoo-touch-up-guide-athens.tsx";
import SeaAfterTattooAthens from "./pages/blog/sea-after-tattoo-athens.tsx";
import TattooHealingTimeAthens from "./pages/blog/tattoo-healing-time-athens.tsx";
import TattooDesignMistakesAthens from "./pages/blog/tattoo-design-mistakes-athens.tsx";
import TattooOnScarsAthens from "./pages/blog/tattoo-on-scars-athens.tsx";
import TattooInfectionSignsAthens from "./pages/blog/tattoo-infection-signs-athens.tsx";
import WhatToEatBeforeTattooAthens from "./pages/blog/what-to-eat-before-tattoo-athens.tsx";
import PosEpilegeisTattooArtistGiaStilAthina from "./pages/blog/pos-epilegeis-tattoo-artist-gia-stil-athina.tsx";
import TatouazAthinaTouristes from "./pages/blog/tatouaz-athina-touristes.tsx";
import LathiProtoTatouazAthina from "./pages/blog/lathi-proto-tatouaz-athina.tsx";
import TattooStudioAthinaIPeiraias from "./pages/blog/tattoo-studio-athina-i-peiraias.tsx";
import FotografiaSeTatouazAthina from "./pages/blog/fotografia-se-tatouaz-athina.tsx";
import PosBriskeisIdeaTatouazAthina from "./pages/blog/pos-briskeis-idea-tatouaz-athina.tsx";
import PoiaTatouazKaliptontaiCoverUpAthina from "./pages/blog/poia-tatouaz-kaliptontai-cover-up-athina.tsx";
import CoverUpILaserAthina from "./pages/blog/cover-up-i-laser-athina.tsx";
import TatouazKentroAthinas from "./pages/blog/tatouaz-kentro-athinas.tsx";
import PioSyxnaLathiEpilogiSxediouTatouazAthina from "./pages/blog/pio-syxna-lathi-epilogi-sxediou-tatouaz-athina.tsx";
import TatouazAreseiSe10XroniaAthina from "./pages/blog/tatouaz-aresei-se-10-xronia-athina.tsx";
import PosKatalabaineisTatouazMolynsiAthina from "./pages/blog/pos-katalabaineis-tatouaz-molynsi-athina.tsx";
import BoroTatouazAnEimaiArrostosAthina from "./pages/blog/boro-tatouaz-an-eimai-arrostos-athina.tsx";
import BoroGymnastikoMetaTatouazAthina from "./pages/blog/boro-gymnastiko-meta-tatouaz-athina.tsx";
import TatouazXefloudizeiFagourizeiAthina from "./pages/blog/tatouaz-xefloudizei-fagourizei-athina.tsx";
import TatouazPleuraPosoPonaeiAthina from "./pages/blog/tatouaz-pleura-poso-ponaei-athina.tsx";
import PioEpodynaSimeiaTatouazAthina from "./pages/blog/pio-epodyna-simeia-tatouaz-athina.tsx";
import LigoteroEpodynaSimeiaTatouazAthina from "./pages/blog/ligotero-epodyna-simeia-tatouaz-athina.tsx";
import TattooStudioNearExarchia from "./pages/blog/tattoo-studio-near-exarchia.tsx";
import TattooStudioNearAmbelokipi from "./pages/blog/tattoo-studio-near-ambelokipi.tsx";
import TattooStudioNearKypseli from "./pages/blog/tattoo-studio-near-kypseli.tsx";
import TattooStudioNearNeapoliExarchia from "./pages/blog/tattoo-studio-near-neapoli-exarchia.tsx";
import TattooStudioNearKolonaki from "./pages/blog/tattoo-studio-near-kolonaki.tsx";
import TattooStudioNearPagkrati from "./pages/blog/tattoo-studio-near-pagkrati.tsx";
import TattooStudioNearSyntagmaMonastiraki from "./pages/blog/tattoo-studio-near-syntagma-monastiraki.tsx";
import TattooStudioNearPetralona from "./pages/blog/tattoo-studio-near-petralona.tsx";

//Force Rebuild

// Lazy-loaded admin pages
const AdminLayout = lazy(() => import('./pages/dashboard/admin/AdminLayout'));
const AdminOverview = lazy(() => import('./pages/dashboard/admin/AdminOverview'));
const AdminAnalytics = lazy(() => import('./pages/dashboard/admin/AdminAnalytics'));
const AdminEntries = lazy(() => import('./pages/dashboard/admin/AdminEntries'));
const AdminArtists = lazy(() => import('./pages/dashboard/admin/AdminArtists'));
const AdminArtistView = lazy(() => import('./pages/dashboard/admin/AdminArtistView'));
const AdminPayments = lazy(() => import('./pages/dashboard/admin/AdminPayments'));
const AdminNetProfit = lazy(() => import('./pages/dashboard/admin/AdminNetProfit'));
const AdminExpenses = lazy(() => import('./pages/dashboard/admin/AdminExpenses'));
const AdminGoals = lazy(() => import('./pages/dashboard/admin/AdminGoals'));
const AdminCompare = lazy(() => import('./pages/dashboard/admin/AdminCompare'));
const AdminArtistPerformance = lazy(() => import('./pages/dashboard/admin/AdminArtistPerformance'));
const AdminReports = lazy(() => import('./pages/dashboard/admin/AdminReports'));
const AdminAssistant = lazy(() => import('./pages/dashboard/admin/AdminAssistant'));
import { ConsentProvider } from './context/ConsentContext';
import AuthMenu from './components/auth/AuthMenu';
import CookieBanner from './components/CookieBanner';
import CookieManagerModal from './components/CookieManagerModal';
import TrackingGate from './components/TrackingGate';
import { fetchSpinWheelEnabled, subscribeSpinWheel } from './lib/siteSettings';
import './i18n';
import './index.css';
import logoFavicon from './assets/favicon.png';

const ensureFavicon = (href: string) => {
  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
};

ensureFavicon(logoFavicon);

function ForwardHashToReset() {
  const location = useLocation();
  return <Navigate to={{ pathname: '/reset-password', hash: location.hash, search: location.search }} replace />;
}

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/spin', element: <SpinWheel /> },
  { path: '/privacy', element: <PrivacyPolicy /> },
  { path: '/cookies', element: <CookiesPolicy /> },
  { path: '/terms', element: <TermsOfService /> },
  { path: '/athens-tattoo-studio-locations', element: <AthensTattooStudioLocations /> },
  // Tattoo service pages are fully static HTML served by Netlify (not React routes).
  { path: '/reset-password', element: <ResetPassword /> },
  { path: '/account/update-password', element: <ForwardHashToReset /> },
  { path: '/dashboard', element: <DashboardRouter /> },
  { path: '/dashboard/login', element: <DashboardLogin /> },
  { path: '/blog', element: <BlogIndex /> },
  { path: '/blog/first-tattoo-athens', element: <FirstTattooAthens />},
  { path: '/blog/tattoo-aftercare-athens', element: <TattooAfterCareAthens />},
  { path: '/blog/tattoo-care-athens', element: <TattooCareAthens />},
  { path: '/blog/tattoo-styles-athens', element: <TattooStylesAthens />},
  { path: '/blog/tattoo-trends-athens', element: <TattooTrendsAthens />},
  { path: '/blog/tattoo-cost-athens', element: <TattooCostAthens />},
  { path: '/blog/tattoo-artist-athens', element: <TattooArtistAthens />},
  { path: '/blog/fine-line-tattoo-guide-athens', element: <FineLineTattooGuideAthens />},
  { path: '/blog/tattoo-cover-up-athens', element: <TattooCoverUpAthens />},
  { path: '/blog/tattoo-pain-guide-athens', element: <TattooPainGuideAthens />},
  { path: '/blog/tattoo-placement-guide-athens', element: <TattooPlacementGuideAthens />},
  { path: '/blog/minimal-tattoo-ideas-athens', element: <MinimalTattooIdeasAthens />},
  { path: '/blog/tattoo-style-guide-athens', element: <TattooStyleGuideAthens />},
  { path: '/blog/first-tattoo-design-athens', element: <FirstTattooDesignAthens />},
  { path: '/blog/tattoo-symbolism-guide-athens', element: <TattooSymbolismGuideAthens />},
  { path: '/blog/meaningful-tattoo-ideas-athens', element: <MeaningfulTattooIdeasAthens />},
  { path: '/blog/summer-tattoo-care-athens', element: <SummerTattooCareAthens />},
  { path: '/blog/laser-vs-cover-up-athens', element: <LaserVsCoverUpAthens />},
  { path: '/blog/walk-in-vs-appointment-athens', element: <WalkInVsAppointmentAthens />},
  { path: '/blog/best-time-for-tattoo-athens', element: <BestTimeForTattooAthens />},
  { path: '/blog/fine-line-tattoo-athens', element: <FineLineTattooAthens />},
  { path: '/blog/custom-tattoo-process-athens', element: <CustomTattooProcessAthens />},
  { path: '/blog/tattoo-difficult-placements-athens', element: <TattooDifficultPlacementsAthens />},
  { path: '/blog/tattoo-timing-athens', element: <TattooTimingAthens />},
  { path: '/blog/small-tattoo-cost-athens', element: <SmallTattooCostAthens />},
  { path: '/blog/tattoo-touch-up-guide-athens', element: <TattooTouchUpGuideAthens />},
  { path: '/blog/sea-after-tattoo-athens', element: <SeaAfterTattooAthens />},
  { path: '/blog/tattoo-healing-time-athens', element: <TattooHealingTimeAthens />},
  { path: '/blog/tattoo-design-mistakes-athens', element: <TattooDesignMistakesAthens />},
  { path: '/blog/tattoo-on-scars-athens', element: <TattooOnScarsAthens />},
  { path: '/blog/tattoo-infection-signs-athens', element: <TattooInfectionSignsAthens />},
  { path: '/blog/what-to-eat-before-tattoo-athens', element: <WhatToEatBeforeTattooAthens />},
  { path: '/blog/pos-epilegeis-tattoo-artist-gia-stil-athina', element: <PosEpilegeisTattooArtistGiaStilAthina />},
  { path: '/blog/tatouaz-athina-touristes', element: <TatouazAthinaTouristes />},
  { path: '/blog/lathi-proto-tatouaz-athina', element: <LathiProtoTatouazAthina />},
  { path: '/blog/tattoo-studio-athina-i-peiraias', element: <TattooStudioAthinaIPeiraias />},
  { path: '/blog/fotografia-se-tatouaz-athina', element: <FotografiaSeTatouazAthina />},
  { path: '/blog/pos-briskeis-idea-tatouaz-athina', element: <PosBriskeisIdeaTatouazAthina />},
  { path: '/blog/poia-tatouaz-kaliptontai-cover-up-athina', element: <PoiaTatouazKaliptontaiCoverUpAthina />},
  { path: '/blog/cover-up-i-laser-athina', element: <CoverUpILaserAthina />},
  { path: '/blog/tatouaz-kentro-athinas', element: <TatouazKentroAthinas />},
  { path: '/blog/pio-syxna-lathi-epilogi-sxediou-tatouaz-athina', element: <PioSyxnaLathiEpilogiSxediouTatouazAthina />},
  { path: '/blog/tatouaz-aresei-se-10-xronia-athina', element: <TatouazAreseiSe10XroniaAthina />},
  { path: '/blog/pos-katalabaineis-tatouaz-molynsi-athina', element: <PosKatalabaineisTatouazMolynsiAthina />},
  { path: '/blog/boro-tatouaz-an-eimai-arrostos-athina', element: <BoroTatouazAnEimaiArrostosAthina />},
  { path: '/blog/boro-gymnastiko-meta-tatouaz-athina', element: <BoroGymnastikoMetaTatouazAthina />},
  { path: '/blog/tatouaz-xefloudizei-fagourizei-athina', element: <TatouazXefloudizeiFagourizeiAthina />},
  { path: '/blog/tatouaz-pleura-poso-ponaei-athina', element: <TatouazPleuraPosoPonaeiAthina />},
  { path: '/blog/pio-epodyna-simeia-tatouaz-athina', element: <PioEpodynaSimeiaTatouazAthina />},
  { path: '/blog/ligotero-epodyna-simeia-tatouaz-athina', element: <LigoteroEpodynaSimeiaTatouazAthina />},
  { path: '/blog/tattoo-studio-near-exarchia', element: <TattooStudioNearExarchia />},
  { path: '/blog/tattoo-studio-near-ambelokipi', element: <TattooStudioNearAmbelokipi />},
  { path: '/blog/tattoo-studio-near-kypseli', element: <TattooStudioNearKypseli />},
  { path: '/blog/tattoo-studio-near-neapoli-exarchia', element: <TattooStudioNearNeapoliExarchia />},
  { path: '/blog/tattoo-studio-near-kolonaki', element: <TattooStudioNearKolonaki />},
  { path: '/blog/tattoo-studio-near-pagkrati', element: <TattooStudioNearPagkrati />},
  { path: '/blog/tattoo-studio-near-syntagma-monastiraki', element: <TattooStudioNearSyntagmaMonastiraki />},
  { path: '/blog/tattoo-studio-near-petralona', element: <TattooStudioNearPetralona />},
  { path: '/en', element: <App /> },

  {
    path: '/dashboard/admin',
    element: (
      <Suspense fallback={<div />}>
        <AdminLayout />
      </Suspense>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard/admin/overview" replace /> },
      { path: 'overview', element: <Suspense fallback={<div />}><AdminOverview /></Suspense> },
      { path: 'analytics', element: <Suspense fallback={<div />}><AdminAnalytics /></Suspense> },
      { path: 'entries', element: <Suspense fallback={<div />}><AdminEntries /></Suspense> },
      { path: 'artists', element: <Suspense fallback={<div />}><AdminArtists /></Suspense> },
      { path: 'artists/:artistId/view', element: <Suspense fallback={<div />}><AdminArtistView /></Suspense> },
      { path: 'payments', element: <Suspense fallback={<div />}><AdminPayments /></Suspense> },
      { path: 'net-profit', element: <Suspense fallback={<div />}><AdminNetProfit /></Suspense> },
      { path: 'expenses', element: <Suspense fallback={<div />}><AdminExpenses /></Suspense> },
      { path: 'goals', element: <Suspense fallback={<div />}><AdminGoals /></Suspense> },
      { path: 'compare', element: <Suspense fallback={<div />}><AdminCompare /></Suspense> },
      { path: 'artist-performance', element: <Suspense fallback={<div />}><AdminArtistPerformance /></Suspense> },
      { path: 'reports', element: <Suspense fallback={<div />}><AdminReports /></Suspense> },
      { path: 'assistant', element: <Suspense fallback={<div />}><AdminAssistant /></Suspense> },
    ],
  },
  { path: '/dashboard/artist', element: <ArtistDashboard /> },
  { path: '*', element: <NotFound /> },
]);

const rootElement = document.getElementById('root')!;
const currentPath = window.location.pathname;
// Only the Greek homepage uses full island-mounting (pre-rendered #root must not be replaced).
// /en renders the full SPA so React controls the language — its pre-rendered content is for SEO only.
const isStaticPage = currentPath === '/';

if (isStaticPage) {
  // Homepage is fully static HTML — do NOT touch #root.
  // Mount cookie consent + tracking into the overlay container.
  const overlaysEl = document.getElementById('react-overlays');
  if (overlaysEl) {
    createRoot(overlaysEl).render(
      <StrictMode>
        <ConsentProvider>
          <CookieBanner />
          <CookieManagerModal />
          <TrackingGate metaPixelId={(import.meta as any).env?.VITE_META_PIXEL_ID} gtagId={(import.meta as any).env?.VITE_GTAG_ID} />
        </ConsentProvider>
      </StrictMode>
    );
  }
  // Mount AuthMenu into the nav placeholders.
  const authDesktop = document.getElementById('nav-auth-desktop');
  const authMobile = document.getElementById('nav-auth-mobile');
  const authApp = (
    <StrictMode>
      <HelmetProvider>
        <AuthProvider>
          <ConsentProvider>
            <AuthMenu />
          </ConsentProvider>
        </AuthProvider>
      </HelmetProvider>
    </StrictMode>
  );
  if (authDesktop) createRoot(authDesktop).render(authApp);
  if (authMobile) createRoot(authMobile).render(authApp);

  // Hide static `/spin` links if the wheel is disabled by admin.
  function applySpinVisibility(enabled: boolean) {
    try {
      const links = document.querySelectorAll<HTMLElement>('[data-spin-link]');
      links.forEach((el) => {
        el.style.display = enabled ? '' : 'none';
      });
    } catch {}
  }
  fetchSpinWheelEnabled()
    .then((enabled) => applySpinVisibility(enabled))
    .catch(() => {});
  subscribeSpinWheel((enabled) => applySpinVisibility(enabled));
} else {
  // All other routes — full React SPA
  const app = (
    <StrictMode>
      <HelmetProvider>
        <AuthProvider>
          <ConsentProvider>
            <RouterProvider router={router} />
            <CookieBanner />
            <CookieManagerModal />
            <TrackingGate metaPixelId={(import.meta as any).env?.VITE_META_PIXEL_ID} gtagId={(import.meta as any).env?.VITE_GTAG_ID} />
          </ConsentProvider>
        </AuthProvider>
      </HelmetProvider>
    </StrictMode>
  );

  // /en pre-rendered content in en/index.html uses island mounting, not full SSR —
  // hydrating it would cause mismatches. Use createRoot so React renders fresh.
  if (rootElement.hasChildNodes() && currentPath !== '/en') {
    hydrateRoot(rootElement, app);
  } else {
    createRoot(rootElement).render(app);
  }
}
